import { Scrollbar } from '@betgames/bg-tools';
import { useCallback } from 'react';
import {
    GamificationNotificationType,
    ModalName,
    gamificationStore,
    useModalsManager,
} from '@bg-shared';

import { Message } from '../Message';
import { IMessage } from '../interfaces';
import classes from './GamificationNotificationsList.module.scss';
import { GamificationModal } from '../../Modals/GamificationModal/GamificationModal';
import { useUnreadMessages } from '../hooks/useUnreadMessages';

const MAX_NOTIFICATIONS = 20;

export const GamificationNotificationsList = (): JSX.Element => {
    const modalManager = useModalsManager();
    const unreadMessages = useUnreadMessages();

    const setMessageRead = useCallback((message: IMessage): void => {
        if (message.type === GamificationNotificationType.CHALLENGE) {
            gamificationStore.markBadgeSeen(message.id);
        } else {
            gamificationStore.markInboxSeen(message.id);
        }

        gamificationStore.setNotificationMessage({ type: message.type, id: message.id });
        modalManager.open(ModalName.GAMIFICATION, GamificationModal);
    }, []);

    return (
        <div className={classes.content}>
            <ul className={classes.list} data-qa="area-notification-list">
                <Scrollbar alwaysShowTracks continuousScrolling={false}>
                    {unreadMessages.slice(0, MAX_NOTIFICATIONS).map((message) => (
                        <Message
                            onClick={() => setMessageRead(message)}
                            key={message.id}
                            id={message.id}
                            type={message.type}
                            title={message.title}
                            date={message.date}
                        />
                    ))}
                </Scrollbar>
            </ul>
        </div>
    );
};
